import { render, staticRenderFns } from "./MainFields.vue?vue&type=template&id=05da364c&"
import script from "./MainFields.vue?vue&type=script&lang=js&"
export * from "./MainFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports